// Shared option lists for Phase 3.5 Administration UI.

// Roles offered in the create/edit form. `ownerOnly` roles are only selectable
// by a Global Administrator. Friendly labels only — never expose raw ids.
export const ROLE_OPTIONS = [
  { value: 'owner', label: 'Global Administrator', ownerOnly: true, type: 'Internal' },
  { value: 'admin', label: 'Administrator', type: 'Internal' },
  { value: 'field_user', label: 'Field Personnel', type: 'Internal' },
  { value: 'client_facilities_director', label: 'Facilities Director', type: 'External' },
  { value: 'client_location_requestor', label: 'Location Requestor', type: 'External' },
];

export const EXTERNAL_ROLES = ['client_facilities_director', 'client_location_requestor'];

// Managed-but-extensible internal subtype suggestions (free text via datalist).
export const EMPLOYEE_SUBTYPES = [
  'Operations Manager',
  'Supervisor',
  'Route Technician',
  'Technician',
];

export const LANGUAGES = ['English', 'Spanish', 'Portuguese', 'French'];

export const DEFAULT_TIME_ZONE = 'America/New_York';

// Standardized US time zones — display label + IANA value. ET/CT/MT/PT auto-adjust for DST.
export const TIME_ZONES = [
  { value: 'America/New_York', label: 'Eastern Time (ET) — Miami, Florida' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Phoenix', label: 'Arizona Time (MST)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HST)' },
  { value: 'America/Puerto_Rico', label: 'Atlantic Time (AST)' },
];

export const tzLabel = (value) =>
  (TIME_ZONES.find((t) => t.value === value) || {}).label || value || 'Eastern Time (ET) — Miami, Florida';

export const roleType = (role) =>
  EXTERNAL_ROLES.includes(role) ? 'External' : 'Internal';
